var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0288d1",
    d: "M24 4a20 20 0 1 0 0 40 20 20 0 1 0 0-40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14 19h4v15h-4zm1.988-2h-.022C14.772 17 14 16.11 14 14.999c0-1.135.796-1.999 2.011-1.999 1.217 0 1.966.864 1.989 1.999C18 16.11 17.228 17 15.988 17M35 24.5a5.5 5.5 0 0 0-5.5-5.5 5.49 5.49 0 0 0-4.5 2.344V19h-4v15h4v-8a3 3 0 1 1 6 0v8h4z"
  })));
};
export default SvgLinkedin;